import clsx from 'clsx';
import styles from 'components/UI/V3/Table/Cell/TableCell.module.scss';
import React from 'react';

type TableCellProps = React.ComponentProps<'td'> & {
    isActions?: boolean;
};

export const TableCell: React.FC<TableCellProps> = ({ children, className, isActions, ...props }) => {
    return (
        <td
            className={clsx(styles.root, className)}
            {...props}
        >
            <div
                className={clsx(styles.wrapper, {
                    [styles.actionsCell]: isActions
                })}
            >
                {children}
            </div>
        </td>
    );
};
